import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import ModalPhotos from "./ModalPhotos";
import {Product, ShippingValue } from "data/data";
import Policy from "./Policy";
import SectionSliderProductCard from "components/SectionSliderProductCard";
import ModalViewAllReviews from "./ModalViewAllReviews";
import { useParams } from 'react-router-dom';
import ProductService from "app/services/productService";
import { Helmet } from "react-helmet-async";
import LikeButton from "components/LikeButton";
import MessageService from "app/services/messageService";
import { AddIcon, MessageIcon, ShippingIcon, ShopIcon } from "components/icons";
import Prices from "components/Prices";
import NcInputNumber from "components/NcInputNumber";
import Basketervice from "app/services/basketService";
export interface ProductDetailPage2Props {
  className?: string;
}
interface Params{
  token:string
}
const ProductDetailPage: FC<ProductDetailPage2Props> = ({
  className = "",
}) => {
  let { slug, id } = useParams();


  const [sizeSelected, setSizeSelected] = React.useState("");


  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModalViewAllReviews, setIsOpenModalViewAllReviews] = useState(false);
  const [openFocusIndex, setOpenFocusIndex] = useState(0);
  const [product, setProduct] = useState<Product>()
  const [name, setName] = React.useState("");

  const [medias, setMedias] = React.useState([]);
  const [products, setProducts] = useState<Product[]>([]);

  const [shipping, setShipping] = useState<ShippingValue[]>([]);
  const [colorSelectedId, setColorSelectedId] = useState<number>();

  const [sizeSelectedId, setSizeSelectedId] = useState<number>();
  
  useEffect(() => {

    ProductService.getProduitById(`${id}`).then(data =>{
        setProduct(data)
        setName(data.name)
        setMedias(data.medias.map((m: any)=> m.path))
        setShipping(data.shipping)
    })
    ProductService.getProducts({
      page: 0,
      query: slug?.replaceAll('-', '|')
    }).then(data => {

      setProducts(data)
    })
  }, [slug])




  const handleOpenModal = (index: number) => {
    setIsOpen(true);
    setOpenFocusIndex(index);
  };

  const handleCloseModal = () => setIsOpen(false);


  const sendMessage = () => {
    MessageService.newMessage({
        message: id,
        type: 'item',
        received: product?.market?.username
      }).then(data => {
        window.location.replace("/messages/"+product?.market?.username);
      
      })
  }

  const Color = (porpos: any) => {
    
    const color = porpos.color
    return(
      <span onClick={porpos.onClick} className={`${porpos.border ? 'border-4' : ''} w-6 h-6 mr-2 rounded-full `} style={{backgroundColor: color.color}}></span>
      
    )
  }
 
  const RenderColorList = () => {
    const colors = product?.colors
    
    return(
      <>
      <div className="" >
        
        <div className="flex">
          {
            colors?.map((c, i) => {
              const isActive = c.id === colorSelectedId;
              return (
                
                <Color key={i}  
                  onClick={()=>{
                    setColorSelectedId(c.id)
                  }}
                color={c} border={isActive}></Color>
              )
            })
          }
        </div>
       
      </div>
        
      </>
    )
  }

  const RenderSizeList = () => {
    const allOfSizes = ["XS", "S", "M", "L", "XL", "2XL", "3XL"]
    const  sizes = product?.size?.map((s) => s.value)
  
    if (!allOfSizes || !sizes || !sizes.length) {
      return null;
    }
    return (
      <div>
        <div className="flex justify-between font-medium text-sm">
          <label htmlFor="">
            <span className="">
            Taille:
              <span className="ml-1 font-semibold">{sizeSelected}</span>
            </span>
          </label>

        </div>
        <div className="grid grid-cols-4 gap-2 mt-3">
          {allOfSizes.map((size, index) => {
            const isActive = size === sizeSelected;
            const sizeOutStock = !sizes.includes(size);
            const sizeObj =  product?.size?.filter((s) => s.value == size)[0]
            
            return (
              <div
                key={index}
                className={`relative h-10 sm:h-11 rounded-2xl border flex items-center justify-center 
                text-sm sm:text-base uppercase font-semibold select-none overflow-hidden z-0 ${
                  sizeOutStock
                    ? "text-opacity-20 dark:text-opacity-20 cursor-not-allowed"
                    : "cursor-pointer"
                } ${
                  isActive
                    ? "bg-primary-6000 border-primary-6000 text-white hover:bg-primary-6000"
                    : "border-slate-300 dark:border-slate-600 text-slate-900 dark:text-slate-200 hover:bg-neutral-50 dark:hover:bg-neutral-700"
                }`}
                onClick={() => {
                  if (sizeOutStock) {
                    return;
                  }
                  setSizeSelectedId(sizeObj?.id)
                  setSizeSelected(size);
                }}
              >
                {size}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const addToCard = () => {
   
    if (colorSelectedId && sizeSelectedId ){
     
      const data = {
        quantity: 1,

        size_id: sizeSelectedId,
        color_id: colorSelectedId,
        product_id: id,
     }
    //  console.log(data)
    Basketervice.add(data).then(data => console.log(data))
    }
  }

  const renderSectionSidebar = () => {

    return (
      <div className="listingSectionSidebar__wrap lg:shadow-lg">
        <div className="space-y-7 lg:space-y-8">
          {/* PRICE */}
          <div className="">
            
            {/* ---------- 1 HEADING ----------  */}
            <div className="flex items-center justify-between space-x-5">
           
              <div className="flex text-2xl font-semibold">
                
                { product?.discount ?
                <div className="flex">
                 <Prices price={product?.price} className="line-through " contentClass="text-xs py-1 px-2 md:py-1.5 md:px-2.5 text-sm font-medium border-none text-red-600"/> 
                 <Prices price={product?.discount} />
                </div>
                : <Prices price={product?.price} />}
              </div>

              <a
                href="#reviews"
                className="flex items-center text-sm font-medium"
              >
                
                {/* <span className="ml-1.5 flex">
                  <span>4.9 </span>
                  <span className="mx-1.5">·</span>
                  <span className="text-slate-700 dark:text-slate-400 underline">
                    142 reviews
                  </span>
                </span> */}
              </a>
            </div>

            {/* ---------- 3 VARIANTS AND SIZE LIST ----------  */}
            <div className="mt-6 space-y-7 lg:space-y-8">
              {/* <div className="">{renderVariants()}</div> */}
              <div className="flex"><RenderColorList /></div>
              <div className=""><RenderSizeList/></div>
            </div>
          </div>
          {/*  ---------- 4  QTY AND ADD TO CART BUTTON */}
          <div className="flex space-x-3.5">
                <div className="flex items-center justify-center bg-slate-100/70 dark:bg-slate-800/70 px-2 py-3 sm:p-3.5 rounded-full">
                <NcInputNumber
                    defaultValue={1}
                    // onChange={setQualitySelected}
                />
                </div>
                <ButtonPrimary onClick={addToCard}  sizeClass = "py-3 px-4 sm:py-3.5 ">
                  <ShopIcon className="inline-block w-5 h-5 "/>
                  Ajouter au panier
                  </ButtonPrimary>
            {/* <ButtonPrimary
              className="flex-1 flex-shrink-0"
              onClick={sendMessage}
            >
             
              <MessageIcon className="hidden sm:inline-block w-5 h-5 mb-0.5"/>
              <span className="ml-3">Contacter le vendeur</span>
            </ButtonPrimary> */}
          </div>


        </div>
      </div>
    );
  };

  
  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap !border-b-0 !pb-0">
        <div className="flex justify-between">
          <h2 className="text-2xl sm:text-3xl font-semibold">
                      {product?.name}
          </h2>
        
          {
            <LikeButton  id={Number(id)} className=" top-3 right-3 z-10" />
          }
  
        </div>
       
        <h2 className="text-2xl font-semibold">Détails du produit</h2>
        {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
        <div className="prose prose-sm sm:prose dark:prose-invert sm:max-w-4xl">
          <p>
           {product?.description}
          </p>
         
        </div>
        {/* ---------- 6 ----------  */}
        {
          <Policy data={shipping} slug={slug}/> 
        }
        
      </div>
    );
  };


  return (
    <div
      className={`ListingDetailPage nc-ProductDetailPage2 ${className}`}
      data-nc-id="ProductDetailPage2"
    >
          <Helmet>
        <title>Roupa | {name} </title>
      </Helmet>
      {/* SINGLE HEADER */}
      <>
        <header className="container mt-8 sm:mt-10">
          <div className="relative ">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 lg:gap-6">
              <div
                className="col-span-2 md:col-span-1 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
                onClick={() => handleOpenModal(0)}
              >
                <NcImage
                  containerClassName="aspect-w-3 aspect-h-4 md:absolute md:inset-0"
                  className="object-cover w-full h-full rounded-md sm:rounded-xl"
                  src={medias[0]}
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-40 transition-opacity"></div>
              </div>

              {/*  */}
              <div
                className="col-span-1 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
                onClick={() => handleOpenModal(1)}
              >
                <NcImage
                  containerClassName="absolute inset-0"
                  className="object-cover w-full h-full rounded-md sm:rounded-xl"
                  src={medias[1]}
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-40 transition-opacity"></div>
              </div>

              {/*  */}
              {product?.medias?.slice(2,4).map((item, index) => (
                <div
                  key={index}
                  className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                    index >= 2 ? "block" : ""
                  }`}
                >
                  <NcImage
                    containerClassName="aspect-w-6 aspect-h-5 lg:aspect-h-4"
                    className="object-cover w-full h-full rounded-md sm:rounded-xl "
                    src={item.path || ""}
                  />

                  {/* OVERLAY */}
                  <div
                    className="absolute inset-0 bg-slate-900 bg-opacity-20 opacity-0 hover:opacity-60 transition-opacity cursor-pointer"
                    onClick={() => handleOpenModal(index + 2)}
                  />
                </div>
              ))}
            </div>
            <div
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-white text-slate-500 cursor-pointer hover:bg-slate-200 z-10"
              onClick={() => handleOpenModal(0)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
              <span className="ml-2 text-neutral-800 text-sm font-medium">
              Afficher toutes les photos
              </span>
            </div>
          </div>
        </header>
        {/* MODAL PHOTOS */}
        <ModalPhotos
          imgs={medias}
          isOpen={isOpen}
          onClose={handleCloseModal}
          initFocus={openFocusIndex}
          uniqueClassName="nc-ProductDetailPage2__modalPhotos"
        />
      </>

      {/* MAIn */}
      <main className="container relative z-10 mt-9 sm:mt-11 flex ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-10 lg:pr-14 lg:space-y-14">
          {/* {renderSection1()} */}
          {renderSection2()}
        </div>

        {/* SIDEBAR */}
        <div className="flex-grow">
          <div className="hidden lg:block sticky top-28">
            {renderSectionSidebar()}
          </div>
        </div>
      </main>

      {/* OTHER SECTION */}
      <div className="container pb-24 lg:pb-28 pt-14 space-y-14">
        <hr className="border-slate-200 dark:border-slate-700" />
{/* 
        {renderReviews()}

        <hr className="border-slate-200 dark:border-slate-700" /> */}
     
        <SectionSliderProductCard
          heading="Customers also purchased"
          data={products}
          subHeading=""
          headingFontClassName="text-2xl font-semibold"
          headingClassName="mb-10 text-neutral-900 dark:text-neutral-50"
        />
      </div>

      {/* MODAL VIEW ALL REVIEW */}
      <ModalViewAllReviews
        show={isOpenModalViewAllReviews}
        onCloseModalViewAllReviews={() => setIsOpenModalViewAllReviews(false)}
      />
    </div>
  );
};

export default ProductDetailPage;
